/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ivory_Crisp_Lark_RushInputs */

const en_ivory_crisp_lark_rush = /** @type {(inputs: Ivory_Crisp_Lark_RushInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select the preferred language for all communications and system interface. This affects emails, SMS messages, and portal language.`)
};

const de_ivory_crisp_lark_rush = /** @type {(inputs: Ivory_Crisp_Lark_RushInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wählen Sie die bevorzugte Sprache für alle Kommunikationen und die Systemoberfläche. Dies betrifft E-Mails, SMS-Nachrichten und die Portalsprache.`)
};

/**
* | output |
* | --- |
* | "Select the preferred language for all communications and system interface. This affects emails, SMS messages, and portal language." |
*
* @param {Ivory_Crisp_Lark_RushInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ivory_crisp_lark_rush = /** @type {((inputs?: Ivory_Crisp_Lark_RushInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ivory_Crisp_Lark_RushInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ivory_crisp_lark_rush(inputs)
	return de_ivory_crisp_lark_rush(inputs)
});